import React, { useMemo } from 'react';
import { IPageInfo, User, ViewType, Post } from '../../../state/types';

interface Props {
  pageInfo: IPageInfo;
  ip: string;
  conversation: Post;
  user: User;
  isClearFilterButtonDisabled: boolean;
  resetAllFilters: (props) => void;
}

const AllFromHeader: React.FC<Props> = ({
  resetAllFilters,
  pageInfo,
  ip,
  conversation,
  user,
  isClearFilterButtonDisabled
}) => {
  const { viewType } = pageInfo;

  const { title, text } = useMemo(() => {
    let title,
      text = null;

    switch (viewType) {
      case ViewType.CONVERSATION:
        title = 'Posted in:';
        text = conversation?.title ? conversation.title : conversation?.postUrl;
        break;
      case ViewType.USER:
        title = 'From user:';

        if (user) {
          if (user?.get('isRegistered')) {
            text = user?.getDisplayName();
          } else {
            text = `Guest (${user?.get('id')})`;
          }
        }
        break;
      case ViewType.IP:
        title = 'From IP:';
        text = ip;
        break;
    }

    return { title, text };
  }, [viewType, user, ip, conversation]);

  const onClearFilterClick = () => {
    const { folder } = pageInfo;
    resetAllFilters({ pageInfo: { folder } });
  };

  if (!title || !text) {
    return null;
  }

  return (
    <div className={'all-from-header'}>
      <span className={'text-container'}>
        {title && <span className={'all-from-title'}>{title} </span>}
        {text && <span className={'all-from-text'}>{`"${text}"`}</span>}
      </span>

      <button
        className={'clear-filter-button'}
        disabled={isClearFilterButtonDisabled}
        onClick={onClearFilterClick}
      >
        Clear Filter
      </button>
    </div>
  );
};

export default AllFromHeader;
